import { FormattedFile } from "../context/EntityFileContext";
import { isImageFile } from "@/other/utils/utils";

// Type for files that are confirmed to be images with a valid image URL
export type FormattedImage = NonNullable<
  FormattedFile & {
    originalImageUrl: string;
    size: string;
  }
>;

// Type guard for isImageFile utility that narrows FormattedFile to FormattedImage
export const isImageFileTyped = (file: FormattedFile | null): file is FormattedImage => {
  if (!file) return false;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return (isImageFile as any)(file) && !!file.originalImageUrl;
};
